<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="about-us-background">
          <div class="banner-content-white-text">
            <h1 style="font-family: STCaiyun, Arial, sans-serif;">常见问题解答</h1>
            <hr>
            <p>
              为您提供全面的解答，帮助您快速解决问题。<br>
              <br>
            </p>
            <div class="breadcrumb-container">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                  <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
                </el-breadcrumb-item>
                <el-breadcrumb-item>常见问题解答</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
        </div>

        <div class="contact-container">
          <div class="help-list" style="padding-right: 8px;">
            <div v-for="(item, index) in helpItems"
                 :key="index"
                 class="help-item">
              <div class="help-header"
                   :class="{'is-active': activeItems[index]}"
                   @click="toggleItem(index)">
                <div class="flex items-center py-2 px-5">
                  <h3 class="text-gray-700"><span>{{ index + 1 }}. {{ item.title }}</span></h3>
                  <i class="fas fa-chevron-down ml-auto transition-transform"
                     :class="{'rotate-180': activeItems[index]}"></i>
                </div>
              </div>
              <div class="help-content"
                   :class="{'is-active': activeItems[index]}"
                   v-show="activeItems[index]">
                <pre style="white-space:pre-wrap;overflow-wrap: break-word;font-family: 'Microsoft YaHei', sans-serif;" v-html="item.content"></pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      helpItems: [
        {
          title: '西安伟思特声学科技有限公司是什么性质的企业？',
          content: '我们是一家专注于声学技术研发与应用的高新技术企业，成立于2022年，致力于为工业制造、新能源汽车等领域提供专业的减振降噪解决方案。'
        },
        {
          title: '您公司主要提供哪些产品和服务？',
          content: '我们公司专注于声学领域，提供噪声与振动控制服务、信息技术咨询服务、新能源汽车生产测试设备销售以及实验分析仪器销售等。具体产品和服务详情可以访问我们的官方网站或联系我们获取更多信息。'
        },
        {
          title: '我想与贵公司合作，该如何联系？',
          content: '如果您有合作意向，可以通过以下方式与我们联系：<br>电话：拨打我们的商务合作热线：13279501565。<br>邮箱：发送合作意向书或咨询邮件到：3319323391@qq.com。<br>面谈：如果您方便，可以预约时间到我们公司进行面谈，我们的地址是：西安市长安区西沣路与郭杜西街十字西南角熙峰广场601A。'
        },
        {
          title: '如何进行产品安装和调试？',
          content: '我们提供专业的安装指导和现场调试服务。技术团队会确保产品安装符合规范，并进行必要的声学测试和优化调整。'
        },
        {
          title: '遇到技术问题如何获取支持？',
          content: '您可以通过我们的24小时服务热线、在线客服或预约现场技术支持。我们的工程师团队将为您提供专业的技术咨询和解决方案。'
        },
        {
          title: '您的产品是否提供定制化服务？',
          content: '是的，我们提供定制化服务。我们的团队可以根据您的具体需求，为您设计和制造符合要求的产品和解决方案。请随时与我们联系，详细说明您的需求，我们将为您提供专业的定制服务。'
        },
        {
          title: '您的产品是否提供定制化服务？',
          content: '是的，我们提供定制化服务。我们的团队可以根据您的具体需求，为您设计和制造符合要求的产品和解决方案。请随时与我们联系，详细说明您的需求，我们将为您提供专业的定制服务。'
        },
        {
          title: '你们的售后服务响应时间是多久？',
          content: '我们承诺在接到您的售后请求后，24 小时内响应并提供解决方案。对于紧急问题，我们会优先处理，确保您的问题尽快得到解决。'
        },
        {
          title: '如何进行产品安装和调试？',
          content: '我们提供专业的安装指导和现场调试服务。技术团队会确保产品安装符合规范，并进行必要的声学测试和优化调整。'
        },
        {
          title: '遇到技术问题如何获取支持？',
          content: '您可以通过我们的24小时服务热线、在线客服或预约现场技术支持。我们的工程师团队将为您提供专业的技术咨询和解决方案。'
        }
      ],
      activeItems: []
    };
  },
  created() {
    this.getAllFAQ();
    this.activeItems = Array(this.helpItems.length).fill(false)

  },
  watch: {
    activeItems: {
      handler(newVal) {
        // 查找最新被设置为 true 的索引
        let latestActiveIndex = -1;
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i] && !this.prevActiveItems[i]) {
            latestActiveIndex = i;
            break;
          }
        }
        // 如果找到最新激活的索引，更新 activeItems 数组
        if (latestActiveIndex !== -1) {
          this.activeItems = this.activeItems.map((_, index) => index === latestActiveIndex);
        }
        // 更新前一次的 activeItems 状态
        this.prevActiveItems = [...newVal];
      },
      deep: true,
      immediate: true // 组件加载时立即执行一次 handler
    }
  },
  mounted() {
    const helpList = document.querySelector('.help-list');
    if (helpList) {
      helpList.style.transition = 'all 0.3s ease';
      helpList.style.backgroundColor = '#f9fafb';
      helpList.style.borderRadius = '8px';
      helpList.style.overflow = 'hidden';
    }
  },
  methods: {
    getAllFAQ() {
      this.$api.getFAQ().then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.helpItems = res.data;
      })
    },
    toggleItem(index) {
      this.$set(this.activeItems, index, !this.activeItems[index]);
    }
  }
}
</script>

<style scoped>

.about-us-background {
  width: 100%;
  background-image: url("../../../assets/img/contact-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* 面包屑容器样式 */
.breadcrumb-container {
  position: absolute;
  left: 50%;
  margin-top: 175px;
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  padding: 8px 16px;
  border-radius: 4px;
  width: 155px;
}


.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

.contact-container {
  max-width: 1200px;
  margin: 100px auto;
}

.help-item {
  border-bottom: 1px solid #e5e7eb;
  background-color: rgba(255, 255, 255, 0.4); /* 添加半透明白色背景 */
}

.help-item:last-child {
  border-bottom: none;
}

.help-header {
  cursor: pointer;
  padding: 8px 0;
}

.help-header:hover {
  background-color: #f9fafb;
}

.help-header.is-active {
  background-color: #f9fafb;
}

.help-content {
  transition: all 0.3s ease;
}

.help-content.is-active {
  padding: 0 20px 16px;
}

.rotate-180 {
  transform: rotate(180deg);
}

.help-list {
  background-image: url('~@/assets/img/faq-img.png'); /* 使用 ~@ 来引用 assets 目录下的图片 */
  background-size: cover; /* 使背景图片覆盖整个容器 */
  background-position: center; /* 背景图片居中 */
  width: 100%; /* 宽度设置为 100% */
  height: 100vh; /* 高度设置为 100vh，使背景图片覆盖整个视口 */
}

</style>